import { Clipboard } from '@angular/cdk/clipboard';
import { Component, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { LoadingService } from '../../../../services';
import { AlertService } from '../../../../services/alert/alert.service';
import { ChatBotV2DataService } from '../../../../services/chat-bot-v2/chat-bot-v2.data.service';
import { ChatBotV2Service } from '../../../../services/chat-bot-v2/chat-bot-v2.service';
import { ChatBotAsesorV2DialogFeedbackComponent } from '../../chat-bot-asesor-v2-dialog-feedback/chat-bot-asesor-v2-dialog-feedback.component';

@Component({
  selector: 'app-chat-bot-asesor-v2-chat-historial',
  templateUrl: './chat-bot-asesor-v2-chat-historial.component.html',
  styleUrls: ['./chat-bot-asesor-v2-chat-historial.component.scss']
})
export class ChatBotAsesorV2ChatHistorialComponent implements OnInit {

  constructor(
    public chatBotV2DS: ChatBotV2DataService,
    private chatBotV2S: ChatBotV2Service,
    private clipboard: Clipboard,
    private loadingService: LoadingService,
    private alertS: AlertService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    setTimeout(() => this.checkHistorial());
  }

  private async checkHistorial() {
    this.chatBotV2DS.historialChat = [];
    if (!this.chatBotV2DS.sessionID) return;
    this.loadingService.showLoading();
    try {
      const historial = await this.chatBotV2S.obtenerHistorial(this.chatBotV2DS.sessionID);
      this.chatBotV2DS.historialChat = this.chatBotV2DS.mapResponseHistorial(historial);
    } catch (error) {
    } finally {
      this.loadingService.hideLoading();
    }
  }

  copiar(text: string, button: MatButton) {
    this.disabledBtn(button);

    this.clipboard.copy(text);
    this.alertS.showSnackBarTopRight({ titulo: 'Copiado', mensaje: 'Has copiado correctamente el texto.', severity: 'success', enFila: true, });
  }

  async feedback(like: boolean, index: number, button: MatButton) {
    let comentario = 'me gusta';

    if (!like) {
      comentario = await this.obtenerComentario();
      if (comentario) comentario = `no me gusta - ${comentario}`;
      if (!comentario) return;
    }

    this.disabledBtn(button);

    const chat = this.chatBotV2DS.historialChat[index];
    const chatPrev = this.chatBotV2DS.historialChat[index - 1];

    const msg = [{
      answer: chat.contenidoMensaje,
      question: chatPrev.contenidoMensaje
    }];

    const config = this.chatBotV2DS.obtenerConfiguracionPregunta();

    const usuario = sessionStorage.getItem('NombreEjecutivoAsesor') + ' - ' + sessionStorage.getItem('sessionId').split('-')[0];

    this.chatBotV2S.enviarFeedBack(comentario, msg, config.consumerId, chat.topic || '', usuario);
    this.alertS.showSnackBarTopRight({ titulo: 'Gracias', mensaje: 'Tu retroalimentación nos permite mejorar.', severity: 'success', enFila: true, });
  }

  private obtenerComentario() {
    const dialogRef = this.dialog.open(ChatBotAsesorV2DialogFeedbackComponent, {
      disableClose: true,
      hasBackdrop: true,
      autoFocus: false,
      panelClass: ['no-padding', 'lg:h-[calc(100vh-16px)]', 'h-full', 'lg:!mr-[16px]', 'lg:!max-w-[375px]', 'w-full', '!max-w-full'],
      position: { right: '0' }
    });
    return dialogRef.afterClosed().toPromise();
  }

  private disabledBtn(button: MatButton) {
    button.disabled = true;
    setTimeout(() => button.disabled = false, 5 * 1000);
  }

}
